<template>
  <button
    class="fr-btn fr-btn--secondary fr-btn--secondary-blue-x fr-btn--icon-right fr-mr-3v redesign-button"
    @click.prevent="click"
  >
    <span class="fr-mr-1v">{{ $t('Start a new discussion') }}</span>
    <span v-html="StartDiscusion" class="button-icon"></span>
  </button>
</template>

<script>
import StartDiscusion from "svg/redesign-icons/discussion.svg";
export default {
  props: {
    onClick: {
      type: Function,
    }
  },
  data() {
    return {
      StartDiscusion
    };
  },
  methods: {
    click() {
      return this.onClick? this.onClick() : this.$bus.emit('discussions.startThread');
    }
  }
}
</script>
